<template>
  <div
    id="blog-table"
    class="blog-table table mx-5 mb-5 h-100">
    <!-- Blog Table Head -->
    <div class="thead">
      <div class="tr">
        <div class="th blog-date">
          Date
        </div>
        <div class="th blog-title">
          Title
        </div>
        <div class="th blog-image">
          Image
        </div>
        <div class="th blog-content">
          Content
        </div>
      </div>
    </div>
    <!-- / Blog Table Head -->

    <!-- Blog Table Body -->
    <div class="tbody">
      <div
        class="tr"
        v-for="blog in blogPosts"
        :key="blog.postId"
        @click="editBlog(blog.postId)">
        <div class="td blog-date">
          {{blog.date | date}}<br>
          <v-icon
            v-if="blog.hidden === 'true'"
            title="This post is currently hidden.">
            mdi-eye-off-outline
          </v-icon>
          <v-icon
            v-else
            title="This post is currently visible.">
            mdi-eye-outline
          </v-icon>
        </div>
        <div class="td blog-title text-truncate">
          {{blog.title}}
        </div>
        <div class="td blog-image">
          <img v-if="blog.imageContent" :src="blog.imageContent" />
          <small
            v-else
            class="font-italic text--secondary">
            not defined
          </small>
        </div>
        <div class="td blog-content">
          <div v-html="blog.content"></div>
        </div>
      </div>
    </div>
    <!-- / Blog Table Body -->
  </div>
</template>

<script>
// import BlogItemMixin from '../mixin.blog-item';

export default {
  name: 'BlogList',
  props: ['blogPosts'],
  /*
  mixins: [
    BlogItemMixin,
  ],
  */
  methods: {
    editBlog(blogId) {
      this.$store.commit('setBlogItemById', blogId);
      this.$router.push({ name: 'BlogEdit', params: { blogId, tab: 'edit' } });
    },
  },
};
</script>

<style lang="scss">
#blog-table {
  height: calc(100% - 100px);
}
</style>
